import React from 'react';
import { useAppCreateReferralContext } from '../context/AppCreateReferralProvider';
import Stepper from './Stepper';
import { CALLBACKS } from '../api/config';
import { useFeatureFlag } from '../utils/useFeatureFlag';
export default function ReferralStepper(_ref) {
  var navigate = _ref.navigate,
    location = _ref.location,
    className = _ref.className,
    isStepReferralSent = _ref.isStepReferralSent,
    addSelectClient = _ref.addSelectClient;
  var _useAppCreateReferral = useAppCreateReferralContext(),
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    draftState = _useAppCreateReferral2.draftState,
    referralId = _useAppCreateReferral2.referralId,
    referralType = _useAppCreateReferral2.referralType;
  var crtb1239AdaptDraftReferralFlow = useFeatureFlag('crtb1239AdaptDraftReferralFlow', false);
  var crtb854ForwardingSuperset = useFeatureFlag('crtb854ForwardingSuperset', false);
  var _isActive = function isActive(route) {
    return location.pathname.includes(route);
  };
  var onNavigateBack = CALLBACKS.onNavigateBack;
  var navigateToAddResources = function navigateToAddResources() {
    return CALLBACKS.onNavigateToAddResources();
  };
  var hasDraftReferral = (draftState === null || draftState === void 0 ? void 0 : draftState.state) === 'draft';
  var isForwardReferralPath = !!referralId && !!referralType;
  var steps = [{
    route: '/referrals/create/add-resources',
    label: 'Add Resources',
    onStepClick: function onStepClick() {
      if (crtb1239AdaptDraftReferralFlow && hasDraftReferral) {
        navigateToAddResources();
      } else {
        onNavigateBack && onNavigateBack(crtb854ForwardingSuperset ? {
          addSelectClient: addSelectClient,
          referralId: referralId
        } : {
          addSelectClient: addSelectClient
        });
      }
    },
    isActive: function isActive() {
      return _isActive(this.route);
    }
  }, {
    route: 'builder',
    label: 'Refer',
    onStepClick: function onStepClick() {
      navigate("/create/".concat(this.route));
    },
    isActive: function isActive() {
      return _isActive(this.route);
    }
  }, !isForwardReferralPath && {
    route: 'supporting-info',
    label: 'Add Assessments',
    onStepClick: function onStepClick() {
      navigate("/create/".concat(this.route));
    },
    isActive: function isActive() {
      return _isActive(this.route);
    }
  }, {
    route: 'review',
    label: 'Review',
    onStepClick: function onStepClick() {
      navigate("/create/".concat(this.route));
    },
    isActive: function isActive() {
      return _isActive(this.route);
    },
    stepCompleted: isStepReferralSent
  }].filter(Boolean);
  if (addSelectClient) {
    steps.unshift({
      route: 'referrals/new/search',
      label: 'Select Client',
      onStepClick: function onStepClick() {
        navigate('referrals/new/search');
      },
      isActive: function isActive() {
        return _isActive(this.route);
      }
    });
  }
  return /*#__PURE__*/React.createElement(Stepper, {
    steps: steps,
    className: className
  });
}
//# sourceMappingURL=ReferralStepper.js.map